import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferenceModalComponent } from './reference-modal.component';
import { RefereeCardComponent } from './components/referee-card/referee-card.component';
import { NonRefereeCardComponent } from './components/non-referee-card/non-referee-card.component';
import { TooltipModule as NgxTooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { LifecycleComponent } from './components/lifecycle/lifecycle.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { LifecycleHelpModalComponent } from './components/lifecycle-help-modal/lifecycle-help-modal.component';
import { LifecycleActionTextComponent } from './components/lifecycle-action-text/lifecycle-action-text.component';
import { LoaderModule } from "src/app/components/loader/loader.module";
import { FooterModule } from 'src/app/components/footer/footer.module';
import { AiReferenceSummaryModule, KebabMenuModule, ButtonModule, TooltipModule, TagsModule} from "@xref/xref-lib";
import { AngularSvgIconModule } from 'angular-svg-icon';


@NgModule({
  declarations: [ReferenceModalComponent, RefereeCardComponent, NonRefereeCardComponent, LifecycleComponent, LifecycleHelpModalComponent, LifecycleActionTextComponent],
  imports: [
    CommonModule,
    NgxTooltipModule.forRoot(),
    TooltipEllipsifyModule,
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    LoaderModule,
    FooterModule,
    KebabMenuModule,
    ButtonModule,
    AiReferenceSummaryModule,
    TagsModule,
    TooltipModule,
    AngularSvgIconModule,
  ]
})
export class ReferenceModalModule { }
